import styled from '@emotion/styled';
import Switch from 'react-switch';
import { CheckLightIcon } from '../../assets/icons';
import { theme } from '../../theme';

export interface IPropsToggleButton {
  value: boolean;
  onChange: (checked: boolean) => void;
  dataCy?: string;
  className?: string;
  dataIcom?: string;
}

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const ToggleButton = ({ value, onChange, dataCy, dataIcom, className }: IPropsToggleButton) => {
  return (
    <label data-cy={dataCy} data-icom={dataIcom} className={className}>
      <Switch
        onChange={onChange}
        checked={value}
        offColor={`${theme.colors.actionSecondary.default}`}
        onColor={`${theme.colors.actionPrimary.default}`}
        uncheckedIcon={false}
        checkedIcon={false}
        checkedHandleIcon={
          <IconContainer>
            <CheckLightIcon width={12} height={12} />
          </IconContainer>
        }
        height={24}
        width={40}
        handleDiameter={16}
      />
    </label>
  );
};
